'use client';

import { useContext, useTransition } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { DossierLanguageFilter } from '@/components/ui/data-display/dossier-list/DossierLanguageFilter';
import { DossierList } from '@/components/ui/data-display/dossier-list/DossierList';
import { Feedback } from '@/components/ui/data-display/feedback/Feedback';
import { Loading } from '@/components/ui/overlays/loading/Loading';

export const DossierListBlock = ({ locale, data, languages, cartLink }) => {
	const { st } = useContext(StaticTextContext);
	const [isPending, startTransition] = useTransition();

	const renderContent = () => {
		if (isPending) {
			return (
				<Loading
					visible={isPending}
					texts={{ loading: st('common.loading_information') }}
				/>
			);
		}

		if (data.length === 0) {
			return (
				<Feedback
					data={{
						fields: {
							title: st('shop.product_empty'),
							content: st('shop.product_empty_content'),
						},
					}}
					language={locale}
				/>
			);
		}

		return (
			<DossierList dossiers={data} languages={languages} cartLink={cartLink} />
		);
	};

	return (
		<>
			<DossierLanguageFilter
				languages={languages}
				startTransition={startTransition}
			/>
			{renderContent()}
		</>
	);
};
